import { Button, Tooltip } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isProOrSgp } from '@/infrastructure/auth';
import { pushHistory } from '@/infrastructure/history';

export const TapdTips: FC = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const gotoTapd = () => pushHistory(history, '/setting/product-config', {
    tab: 'tapd',
  });
  const gotoDefect = () => pushHistory(history, '/setting/product-config', {
    tab: 'defect',
  });

  return <Tooltip
    color='#fff'
    overlayInnerStyle={{ width: '300px' }}
    title={
      <div style={{ color: 'black', display: 'flex', alignItems: 'center' }}>
        {t('请先完善{{target}}配置，然后再提单', { target: isProOrSgp() ? t('缺陷管理项目') : 'TAPD' })}
        <Button
          type='link'
          onClick={() => (isProOrSgp() ? gotoDefect() : gotoTapd())}
        >
          {t('去完善')}
        </Button>
      </div>}
  >
    {props.children}
  </Tooltip>;
};
